import { apiBaseUrl, socketServerUrl } from "./connection";

export const SERVER_ADDRESS = apiBaseUrl();
export const SOCKET_SERVER_URL = socketServerUrl(SERVER_ADDRESS);

const Communication_url = {
  // user
  kakao_login: `${SERVER_ADDRESS}user/login/kakaoSync`,
  nick_dup_check: `${SERVER_ADDRESS}user/nick-dup-check`,
  user_join: `${SERVER_ADDRESS}user/join`,
  user_login: `${SERVER_ADDRESS}user/login`,
  seller_login: `${SERVER_ADDRESS}user/seller-login`,
  refresh: `${SERVER_ADDRESS}user/refresh`,
  user_info: `${SERVER_ADDRESS}user/user-info`,
  logout: `${SERVER_ADDRESS}user/logout`,
  dropUser: `${SERVER_ADDRESS}user/drop-user`,
  id_dup_check: `${SERVER_ADDRESS}user/id-dup-check`,
  send_phone_auth: `${SERVER_ADDRESS}user/send-phone-auth`,
  verify_phone_auth: `${SERVER_ADDRESS}user/verify-phone-auth`,
  seller_find_id: `${SERVER_ADDRESS}user/seller/find-id`,
  seller_reset_password: `${SERVER_ADDRESS}user/seller/reset-password`,
  update_profile: `${SERVER_ADDRESS}user/profile`,
  seller_staff: `${SERVER_ADDRESS}user/seller/staff`,
  seller_staff_settings: `${SERVER_ADDRESS}user/seller/staff-settings`,

  // store
  store_name_dup_check: `${SERVER_ADDRESS}store/store-name-dup-check`,
  seller_name_availability: `${SERVER_ADDRESS}store/seller-name-availability`,
  create_store: `${SERVER_ADDRESS}store/store-create`,
  store_info: `${SERVER_ADDRESS}store/store-info`,
  store_info_summary: `${SERVER_ADDRESS}store/store-info-summary`,
  store_update: `${SERVER_ADDRESS}store/store-update`,
  stock_coin: `${SERVER_ADDRESS}store/stock-coin`,
  store_search: `${SERVER_ADDRESS}store/search`,
  home_banners: `${SERVER_ADDRESS}home-banners`,

  // coin
  coin_log_list: `${SERVER_ADDRESS}coin/coin-log-list`,
  coin_charge: `${SERVER_ADDRESS}coin/coin-charging`,
  coin_charging_cancel: `${SERVER_ADDRESS}coin/coin-charging-cancel`,

  // live
  unavailable_time: `${SERVER_ADDRESS}live/unavailable-time`,
  live_schedule_counts: `${SERVER_ADDRESS}live/schedule-counts`,
  create_live: `${SERVER_ADDRESS}live/create-live`,
  get_live_list: `${SERVER_ADDRESS}live/get-live-list`,
  get_main_live_list: `${SERVER_ADDRESS}live/get-main-live-list`,
  get_follow_live_list: `${SERVER_ADDRESS}live/get-follow-live-list`,
  get_live_info: `${SERVER_ADDRESS}live/get-live-info`,
  payment_review_live: `${SERVER_ADDRESS}live/payment-review`,
  get_live_notice: `${SERVER_ADDRESS}live/get-live-notice`,
  create_live_notice: `${SERVER_ADDRESS}live/create-live-notice`,
  delete_live_notice: `${SERVER_ADDRESS}live/delete-live-notice`,
  modify_live_notice: `${SERVER_ADDRESS}live/modify-live-notice`,
  last_live_list: `${SERVER_ADDRESS}live/last-live-list`,
  live_cancel: `${SERVER_ADDRESS}live/live-cancel`,
  live_search: `${SERVER_ADDRESS}live/search-live`,
  send_alimtalk: `${SERVER_ADDRESS}live/send-alimtalk`,
  live_user_ban_check: `${SERVER_ADDRESS}live/live-user-ban-check`,
  motify_live_status: `${SERVER_ADDRESS}live/modify-live-status`,
  alimtalk_follow_check: `${SERVER_ADDRESS}live/alimtalk-follow-check`,
  live_auth_check: `${SERVER_ADDRESS}live/live-auth-check`,
  rehearsal_access: `${SERVER_ADDRESS}live/rehearsal-access`,
  rehearsal_invite: `${SERVER_ADDRESS}live/rehearsal-invite`,

  // relation
  user_ban: `${SERVER_ADDRESS}relation/user-ban`,
  user_unban: `${SERVER_ADDRESS}relation/user-unban`,
  follow_user_list: `${SERVER_ADDRESS}relation/follow-user-list`,
  ban_user_list: `${SERVER_ADDRESS}relation/ban-user-list`,
  store_follow: `${SERVER_ADDRESS}relation/store-follow`,
  store_unfollow: `${SERVER_ADDRESS}relation/store-unfollow`,

  // product
  product_list: `${SERVER_ADDRESS}product/product-list`,
  sale_product_info: `${SERVER_ADDRESS}product/sale-product-info`,
  product_update: `${SERVER_ADDRESS}product/product-update`,
  product_delete: `${SERVER_ADDRESS}product/product-delete`,
  product_move: `${SERVER_ADDRESS}product/product-move`,
  product_reorder: `${SERVER_ADDRESS}product/product-reorder`,
  product_picture_list: `${SERVER_ADDRESS}product/product-picture-list`,
  product_picture_update: `${SERVER_ADDRESS}product/product-picture-update`,
  capture_product_list: `${SERVER_ADDRESS}product/capture-product-list`,
  capture_image_save: `${SERVER_ADDRESS}product/capture-image-save`,
  product_create: `${SERVER_ADDRESS}product/product-create`,
  search_product: `${SERVER_ADDRESS}product/search-product`,
  product_option_enable: `${SERVER_ADDRESS}product/product-option-enable`,
  option_tag_create: `${SERVER_ADDRESS}product/option-tag-create`,
  option_tag_list: `${SERVER_ADDRESS}product/option-tag-list`,
  option_tag_delete: `${SERVER_ADDRESS}product/option-tag-delete`,
  search_option_tag: `${SERVER_ADDRESS}product/search-option-tag`,
  product_option_save: `${SERVER_ADDRESS}product/product-option-save`,
  product_option_info: `${SERVER_ADDRESS}product/product-option-info`,
  product_option_delete: `${SERVER_ADDRESS}product/product-option-delete`,
  create_last_live_product: `${SERVER_ADDRESS}product/create-last-live-product`,
  product_excel_upload: `${SERVER_ADDRESS}product/product-excel-upload`,
  product_name_list: `${SERVER_ADDRESS}product/product-name-list`,
  is_visable_product: `${SERVER_ADDRESS}product/is-visable-product`,
  product_exposure_cues: `${SERVER_ADDRESS}product/product-exposure-cues`,
  product_exposure_retry: `${SERVER_ADDRESS}product/product-exposure-retry`,

  store_public_profile: `${SERVER_ADDRESS}store/public-profile`,
  seller_profile_lives: `${SERVER_ADDRESS}live/get-live-list-seller-profile`,
  create_card_payment: `${SERVER_ADDRESS}payment/create-card-payment`,
  create_hf_payment: `${SERVER_ADDRESS}payment/create-HF-payment`,
  payment_receipt: `${SERVER_ADDRESS}payment/receipt`,

  // orders
  get_order_list: `${SERVER_ADDRESS}orders/order-list`,
  store_dashboard: `${SERVER_ADDRESS}orders/store-dashboard`,
  order: `${SERVER_ADDRESS}orders/order`,
  order_info: `${SERVER_ADDRESS}orders/order-info`,
  order_address_update: `${SERVER_ADDRESS}orders/order-address-update`,
  order_request_memo: `${SERVER_ADDRESS}orders/order-request-memo`,
  order_shipping_region: `${SERVER_ADDRESS}orders/shipping-region`,
  order_detail_update_cancel: `${SERVER_ADDRESS}orders/order-detail-update-cancel`,
  order_detail_memo: `${SERVER_ADDRESS}orders/order-detail-memo`,
  order_detail_update: `${SERVER_ADDRESS}orders/order-detail-update`,
  order_detail_update_procurement: `${SERVER_ADDRESS}orders/order-detail-update-procurement`,
  order_delete: `${SERVER_ADDRESS}orders/order-delete`,
  update_all_order_status: `${SERVER_ADDRESS}orders/update-all-order-status`,
  order_count: `${SERVER_ADDRESS}orders/order-count`,
  order_live_summary: `${SERVER_ADDRESS}orders/order-live-summary`,
  live_sales_summary: `${SERVER_ADDRESS}orders/live-sales-summary`,
  live_order_count: `${SERVER_ADDRESS}orders/live-order-count`,
  statement_info: `${SERVER_ADDRESS}orders/statement-info`,
  send_statement: `${SERVER_ADDRESS}orders/send-statement`,
  procurement_load: `${SERVER_ADDRESS}orders/procurement-load`,
  procurement_list: `${SERVER_ADDRESS}orders/procurement-list`,
  procurement_memo: `${SERVER_ADDRESS}orders/procurement-memo`,
  procurement_excel: `${SERVER_ADDRESS}orders/procurement-excel`,
  procurement_excel_raw: `${SERVER_ADDRESS}orders/procurement-excel-raw`,
  delivery_excel_upload: `${SERVER_ADDRESS}orders/delivery-excel-upload`,
  oversell_detail: `${SERVER_ADDRESS}orders/oversell-detail`,
  oversell_notification: `${SERVER_ADDRESS}orders/oversell-notification`,
  user_live_cancel_ticket: `${SERVER_ADDRESS}user/user-live-cancel-ticket`,
  issue_cancel_ticket: `${SERVER_ADDRESS}orders/issue-cancel-ticket`,
  cancel_ticket_participants: `${SERVER_ADDRESS}orders/cancel-ticket-participants`,
  grant_cancel_ticket: `${SERVER_ADDRESS}orders/grant-cancel-ticket`,
  grant_cancel_ticket_all: `${SERVER_ADDRESS}orders/grant-cancel-ticket-all`,
  orders_cancel: `${SERVER_ADDRESS}orders/orders_cancel`,

  // file
  upload_license: `${SERVER_ADDRESS}file/upload-license`,
  upload_store_profile: `${SERVER_ADDRESS}file/upload-store-profile`,
  upload_store_banner: `${SERVER_ADDRESS}file/upload-store-banner`,
  upload_live_img: `${SERVER_ADDRESS}file/upload-live-img`,
  upload_live_snapshot: `${SERVER_ADDRESS}file/upload-live-snapshot`,
  replace_live_image: `${SERVER_ADDRESS}file/replace-live-image`,
  upload_product_img: `${SERVER_ADDRESS}file/upload-product-img`,

  // aws-ivs
  live_status: `${SERVER_ADDRESS}aws-ivs/live-status`,
  broadcast_audio_state: `${SERVER_ADDRESS}aws-ivs/audio-state`,
  getStreamInfo: `${SERVER_ADDRESS}aws-ivs/getStreamInfo`,
  release_broadcast_start: `${SERVER_ADDRESS}aws-ivs/release-broadcast-start`,
  playback_info: `${SERVER_ADDRESS}aws-ivs/playback-info`,
  force_quit: `${SERVER_ADDRESS}aws-ivs/force-quit`,

  // chat
  createChatToken: `${SERVER_ADDRESS}aws-ivs-chat/createChatToken`,
  guest_chat_token: `${SERVER_ADDRESS}aws-ivs-chat/guest-chat-token`,

  // inquire
  inquire_create: `${SERVER_ADDRESS}inquire/create`,
  inquire_list: `${SERVER_ADDRESS}inquire/list`,
  inquire_store_list: `${SERVER_ADDRESS}inquire/store-list`,
  inquire_detail: `${SERVER_ADDRESS}inquire/detail`,
  inquire_answer: `${SERVER_ADDRESS}inquire/answer`,
  inquire_update: `${SERVER_ADDRESS}inquire/update`,
  inquire_delete: `${SERVER_ADDRESS}inquire/delete`,
  inquire_answer_update: `${SERVER_ADDRESS}inquire/answer/update`,
  inquire_answer_delete: `${SERVER_ADDRESS}inquire/answer/delete`,
  inquire_answer_picture_add: `${SERVER_ADDRESS}inquire/answer/picture/add`,

  // support chat
  support_conversations: `${SERVER_ADDRESS}support/conversations`,
  support_resolve: `${SERVER_ADDRESS}support/resolve`,
  support_unread_count: `${SERVER_ADDRESS}support/unread-count`,
  support_seller_conversations: `${SERVER_ADDRESS}support/seller/conversations`,
  support_seller_unread_count: `${SERVER_ADDRESS}support/seller/unread-count`,
};

const url = {
  Communication_url,
};
export default url;
